import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdDashboard,
  MdLock,
  MdOutlineShoppingCart,
} from 'react-icons/md';

// Admin Imports
import DashboardsDefault from 'views/admin/dashboards/default';
//import DashboardsRTLDefault from 'views/admin/dashboards/rtl';
import Secciones from 'views/admin/dashboards/secciones';
import DashboardsSmartHome from 'views/admin/dashboards/smartHome';

// // NFT Imports
import NFTMarketplace from 'views/admin/nfts/marketplace';
import NFTPage from 'views/admin/nfts/page';
import NFTCollection from 'views/admin/nfts/collection';
import NFTProfile from 'views/admin/nfts/profile';

// Main Imports
import AccountBilling from 'views/admin/main/account/billing';
import AccountApplications from 'views/admin/main/account/application';
import AccountInvoice from 'views/admin/main/account/invoice';
import AccountSettings from 'views/admin/main/account/settings';
import AccountAllCourses from 'views/admin/main/account/courses';
import AccountCoursePage from 'views/admin/main/account/coursePage';

import UserNew from 'views/admin/main/users/newUser';
import UsersOverview from 'views/admin/main/users/overview';
import UsersReports from 'views/admin/main/users/reports';

import ProfileSettings from 'views/admin/main/profile/settings';
import ProfileOverview from 'views/admin/main/profile/overview';
import ProfileNewsfeed from 'views/admin/main/profile/newsfeed';

import ApplicationsKanban from 'views/admin/main/applications/kanban';
import ApplicationsDataTables from 'views/admin/main/applications/dataTables';
import ApplicationsCalendar from 'views/admin/main/applications/calendar';

import EcommerceNewProduct from 'views/admin/main/ecommerce/newProduct';
import EcommerceProductOverview from 'views/admin/main/ecommerce/overviewProduct';
import EcommerceProductSettings from 'views/admin/main/ecommerce/settingsProduct';
import EcommerceProductPage from 'views/admin/main/ecommerce/pageProduct';
import EcommerceOrderList from 'views/admin/main/ecommerce/orderList';
import ProductosLista from 'views/admin/main/ecommerce/productoslista';
import EcommerceOrderDetails from 'views/admin/main/ecommerce/orderDetails';
import EcommerceReferrals from 'views/admin/main/ecommerce/referrals';

// Others
import OthersNotifications from 'views/admin/main/others/notifications';
import OthersPricing from 'views/admin/main/others/pricing';
import OthersError from 'views/admin/main/others/404';
import Messages from 'views/admin/main/others/messages';

// Auth Imports
import ForgotPasswordCentered from 'views/auth/forgotPassword/ForgotPasswordCentered';
import ForgotPasswordDefault from 'views/auth/forgotPassword/ForgotPasswordDefault';
import LockCentered from 'views/auth/lock/LockCentered';
import LockDefault from 'views/auth/lock/LockDefault';
import SignInCentered from 'views/auth/signIn/SignInCentered';
import SignInDefault from 'views/auth/signIn/SignInDefault';
import SignUpCentered from 'views/auth/signUp/SignUpCentered';
import SignUpDefault from 'views/auth/signUp/SignUpDefault';
import VerificationCentered from 'views/auth/verification/VerificationCentered';
import VerificationDefault from 'views/auth/verification/VerificationDefault';
/////// OBS

import ListaLocales from 'views/admin/main/ecommerce/Locales';
import ListaUsuarios from 'views/admin/main/ecommerce/Usuarios';

import NuevoLocal from 'views/admin/main/ecommerce/NuevoLocal';
import NuevoUsuario from 'views/admin/main/ecommerce/NuevoUsuario';


// VISITANTES

import NuevoVotante from 'views/admin/main/ERP/Votantes/NuevoVotante';
import RegistrosVotantes from 'views/admin/main/ERP/Votantes/RegistrosVotantes';

//  CANDIDATO 
import NuevoCandidato from 'views/admin/main/ERP/Candidatos/NuevoCandidato';
import RegistroCandidato from 'views/admin/main/ERP/Candidatos/RegistroCandidato';

//  CANDIDATO 
import NuevaEncuesta from 'views/admin/main/ERP/Candidatos/NuevaEncuesta';
import RegistroEncuesta from 'views/admin/main/ERP/Candidatos/RegistroEncuesta';

import Encuestas from 'views/admin/main/ERP/Candidatos/Encuestas';

//  Administradores 
import NuevoAdmin from 'views/admin/main/ERP/Usuarios/NuevoAdmin';
import RegistroAdmin from 'views/admin/main/ERP/Usuarios/RegistroAdmin';


//personal
import NuevoPersonal from 'views/admin/main/ERP/Personal/NuevoPersonal';
import RegistroPersonal from 'views/admin/main/ERP/Personal/RegistroPersonal';




// CLIENTES

import NuevoCliente from 'views/admin/main/ERP/Clientes/NuevoCliente';
import RegistrosCliente from 'views/admin/main/ERP/Clientes/RegistrosCliente';



// PROVEEDOR

import NuevoProveedor from 'views/admin/main/ERP/Proveedores/NuevoProveedor';
import RegistroProveedor from 'views/admin/main/ERP/Proveedores/RegistroProveedores';

// COMPRAS

import NuevaCompra from 'views/admin/main/ERP/Compras/NuevaCompra';
import RegistrosCompras from 'views/admin/main/ERP/Compras/RegistrosCompras';

//INGRESOS 

import NuevoIngreso from 'views/admin/main/ERP/Ingresos/NuevoIngreso';
import RegistrosIngresos from 'views/admin/main/ERP/Ingresos/RegistrosIngresos';

// AGENDA DE ACTIVIDADES


import NuevaActividad from 'views/admin/main/ERP/AgendaActividades/NuevaActividad';
import RegistroActividades from 'views/admin/main/ERP/AgendaActividades/RegistroActividades';
import Album from 'views/admin/main/ERP/AgendaActividades/Album';

// Configuracion 

import AjustePositivo from 'views/admin/main/ERP/Configuracion/AjustePositivo';
import AjusteNegativo from 'views/admin/main/ERP/Configuracion/AjusteNegativo';
import CargaInicial from 'views/admin/main/ERP/Configuracion/CargaInicial';
import Notificaciones from 'views/admin/main/ERP/Configuracion/Notificaciones';

//Supervisores
import NuevoSuper from 'views/admin/main/ERP/Supervisores/NuevoPersonal';
import RegistroSuper from 'views/admin/main/ERP/Supervisores/RegistroPersonal';

//import RegistrosIngresos from 'views/admin/main/ERP/Ingresos/RegistrosIngresos';

const routes = [
  // --- Dashboards ---

  
  {
    name: 'Centro de Datos',
    layout: '/admin',
    path: '/dashboards/default',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    component: <DashboardsDefault />,
  },
  // --- NFTs ---
  // {
  //   name: 'NFTs',
  //   path: '/nfts',
  //   icon: (
  //     <Icon
  //       as={MdOutlineShoppingCart}
  //       width="20px"
  //       height="20px"
  //       color="inherit"
  //     />
  //   ),
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Marketplace',
  //       layout: '/rtl',
  //       path: '/nfts/marketplace',
  //       component: <NFTMarketplace />,
  //       secondary: true,
  //     },
  //   ],
  // },
  // // --- Main pages ---
  {
    name: 'Sistema',
    path: '/main',
    icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Votantes',
        layout: '/admin',
        path: '/main/ERP/Votantes/RegistrosVotantes',
        exact: false,
        component: <RegistrosVotantes />,
      },
      {
        name: 'Nuevo Votante',
        layout: '/admin',
        path: '/main/ERP/Votantes/NuevoVotante',
        exact: false,
        component: <NuevoVotante />,
        hidden: true,
      },

      {
        name: 'Candidatos',
        layout: '/admin',
        path: '/main/ERP/Candidatos/RegistroCandidato',
        exact: false,
        component: <RegistroCandidato />,
      },
      {
        name: 'Nuevo Candidato',
        layout: '/admin',
        path: '/main/ERP/Candidatos/NuevoCandidato',
        exact: false,
        component: <NuevoCandidato />,
        hidden: true,
      },

      {
        name: 'Encuestas',
        layout: '/admin',
        path: '/main/ERP/Candidatos/RegistroEncuesta',
        exact: false,
        component: <RegistroEncuesta />,
      },
      {
        name: 'Nueva Encuesta',
        layout: '/admin',
        path: '/main/ERP/Candidatos/NuevaEncuesta',
        exact: false,
        component: <NuevaEncuesta />,
        hidden: true,
      },

      {
        name: 'Supervisores',
        layout: '/admin',
        path: '/main/ERP/Super/RegistroSuper',
        exact: false,
        hidden: true,
        component: <RegistroSuper />,
      },
      {
        name: 'Nuevo Supervisor',
        layout: '/admin',
        path: '/main/ERP/Super/NuevoSuper',
        exact: false,
        component: <NuevoSuper />,
        hidden: true,
      },

      {
        name: 'Administradores',
        layout: '/admin',
        path: '/main/ERP/Usuarios/RegistroAdmin',
        exact: false,
        component: <RegistroAdmin />,
      },
      {
        name: 'Nuevo Admin',
        layout: '/admin',
        path: '/main/ERP/Usuarios/NuevoAdmin',
        exact: false,
        component: <NuevoAdmin />,
        hidden: true,
      },

      {
        name: 'Mi Personal',
        layout: '/admin',
        path: '/main/ERP/Personal/RegistroPersonal',
        exact: false,
        component: <RegistroPersonal />,
      },
      {
        name: 'Nuevo Personal',
        layout: '/admin',
        path: '/main/ERP/Personal/NuevoPersonal',
        exact: false,
        component: <NuevoPersonal />,
        hidden: true,
      },
      // {
      //   name: 'Clientes',
      //   path: '/main/ERP/Clientes',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Nuevo Cliente',
      //       layout: '/admin',
      //       path: '/main/ERP/Clientes/NuevoCliente',
      //       exact: false,
      //       component: <NuevoCliente />,
      //     }, {
      //       name: 'Registro de Clientes',
      //       layout: '/admin',
      //       path: '/main/ERP/Clientes/RegistrosCliente',
      //       exact: false,
      //       component: <RegistrosCliente />,
      //     },
      //   ]
      // },
      {
        name: 'Proveedores',
        layout: '/admin',
        path: '/main/ERP/Proveedor/RegistroProveedores',
        exact: false,
        component: <RegistroProveedor />,
      },
      {
        name: 'Nuevo Proveedor',
        layout: '/admin',
        path: '/main/ERP/Proveedor/NuevoProveedor',
        exact: false,
        component: <NuevoProveedor />,
        hidden: true,
      },

      {
        name: 'Compras',
        layout: '/admin',
        path: '/main/ERP/Compras/RegistrosCompras',
        exact: false,
        component: <RegistrosCompras />,
      },
      {
        name: 'Nueva Compra',
        layout: '/admin',
        path: '/main/ERP/Compras/NuevaCompra',
        exact: false,
        component: <NuevaCompra />,
        hidden: true,
      },
      {
        name: 'Fondos',
        path: '/main/ERP/Fondos',
        hidden: true,
        collapse: true,
        items: [
          {
            name: 'Ajuste Positivo',
            layout: '/admin',
            path: '/main/ERP/Configuracion/AjustePositivo',
            exact: false,
            component: <AjustePositivo />,
          },
          {
            name: 'Ajuste Negativo',
            layout: '/admin',
            path: '/main/ERP/Configuracion/AjusteNegativo',
            exact: false,
            component: <AjusteNegativo />,
          },
        ],
      },
      // {
      //   name: 'Ingresos',
      //   path: '/main/ERP/Ingresos',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Nueva Venta',
      //       layout: '/admin',
      //       path: '/main/ERP/Ingresos/NuevoIngreso',
      //       exact: false,
      //       component: <NuevoIngreso />,
      //     }, {
      //       name: 'Registro de Ventas',
      //       layout: '/admin',
      //       path: '/main/ERP/Ingresos/RegistrosIngresos',
      //       exact: false,
      //       component: <RegistrosIngresos />,
      //     },
      //   ]
      // },
      {
        name: 'Agenda',
        layout: '/admin',
        path: '/main/ERP/AgendaActividades/RegistroActividades',
        exact: false,
        component: <RegistroActividades />,
      },
      {
        name: 'Nueva Actividad',
        layout: '/admin',
        path: '/main/ERP/AgendaActividades/NuevaActividad',
        exact: false,
        component: <NuevaActividad />,
        hidden: true,
      },
      {
        name: 'Galería de Evidencias',
        layout: '/admin',
        path: '/main/ERP/AgendaActividades/Calendario',
        exact: false,
        component: <Album />,
        hidden: true,
      },


      // {
      //   name: 'Account',
      //   path: '/main/account',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Billing',
      //       layout: '/admin',
      //       path: '/main/account/billing',
      //       exact: false,
      //       component: <AccountBilling />,
      //     },
      //     {
      //       name: 'Application',
      //       layout: '/admin',
      //       path: '/main/account/application',
      //       exact: false,
      //       component: <AccountApplications />,
      //     },
      //     {
      //       name: 'Invoice',
      //       layout: '/admin',
      //       path: '/main/account/invoice',
      //       exact: false,
      //       component: <AccountInvoice />,
      //     },
      //     {
      //       name: 'Settings',
      //       layout: '/admin',
      //       path: '/main/account/settings',
      //       exact: false,
      //       component: <AccountSettings />,
      //     },
      //     {
      //       name: 'All Courses',
      //       layout: '/admin',
      //       path: '/main/account/all-courses',
      //       exact: false,
      //       component: <AccountAllCourses />,
      //     },
      //     {
      //       name: 'Course Page',
      //       layout: '/admin',
      //       path: '/main/account/course-page',
      //       exact: false,
      //       component: <AccountCoursePage />,
      //     },
      //   ],
      // },

      // {
      //   name: 'Punto de Venta',
      //   path: '/main/ecommerce',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Nuevo Producto',
      //       layout: '/admin',
      //       path: '/main/pos/nuevo-producto',
      //       exact: false,
      //       component: <EcommerceNewProduct />,
      //     },
      //     {
      //       name: 'Lista de Productos',
      //       layout: '/admin',
      //       path: '/main/ecommerce/product-overview',
      //       exact: false,
      //       component: <EcommerceProductOverview />,
      //     },
      //     {
      //       name: 'Product Settings',
      //       layout: '/admin',
      //       path: '/main/ecommerce/settings',
      //       exact: false,
      //       component: <EcommerceProductSettings />,
      //     },
      //     {
      //       name: 'Product Page',
      //       layout: '/admin',
      //       path: '/main/ecommerce/page-example',
      //       exact: false,
      //       component: <EcommerceProductPage />,
      //     },
      //     {
      //       name: 'Productos',
      //       layout: '/admin',
      //       path: '/main/pos/productos',
      //       exact: false,
      //       component: <ProductosLista />,
      //     },
      //     {
      //       name: 'Pedidos',
      //       layout: '/admin',
      //       path: '/main/pos/pedidos',
      //       exact: false,
      //       component: <RegistrosVotantes />,
      //     },
      //     {
      //       name: 'Configuracion de Sistema',
      //       layout: '/admin',
      //       path: '/main/pos/pedidos',
      //       exact: false,
      //       component: <EcommerceOrderList />,
      //     },
      //     {
      //       name: 'Nuevo Local',
      //       layout: '/admin',
      //       path: '/main/pos/new_local',
      //       exact: false,
      //       component: <NuevoLocal />,
      //     },

      //     {
      //       name: 'Locales',
      //       layout: '/admin',
      //       path: '/main/pos/locales',
      //       exact: false,
      //       component: <ListaLocales />,
      //     },
      //     {
      //       name: 'Nuevo Usuario',
      //       layout: '/admin',
      //       path: '/main/pos/new_usuario',
      //       exact: false,
      //       component: <NuevoUsuario />,
      //     },

      //     {
      //       name: 'Usuarios',
      //       layout: '/admin',
      //       path: '/main/pos/usuarios',
      //       exact: false,
      //       component: <ListaUsuarios />,
      //     },
      //     {
      //       name: 'Detalle de Pedido',
      //       layout: '/admin',
      //       path: '/main/ecommerce/order-details',
      //       exact: false,
      //       component: <EcommerceOrderDetails />,
      //     },
      //     {
      //       name: 'Referrals',
      //       layout: '/admin',
      //       path: '/main/ecommerce/referrals',
      //       exact: false,
      //       component: <EcommerceReferrals />,
      //     },
      //   ],
      // },
      // {
      //   name: 'Users',
      //   path: '/main/users',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'New User',
      //       layout: '/admin',
      //       path: '/main/users/new-user',
      //       exact: false,
      //       component: <UserNew />,
      //     },
      //     {
      //       name: 'Users Overview',
      //       layout: '/admin',
      //       path: '/main/users/users-overview',
      //       exact: false,
      //       component: <UsersOverview />,
      //     },
      //     {
      //       name: 'Users Reports',
      //       layout: '/admin',
      //       path: '/main/users/users-reports',
      //       exact: false,
      //       component: <UsersReports />,
      //     },
      //   ],
      // },
      // {
      //   name: 'Applications',
      //   path: '/main/applications',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Kanban',
      //       layout: '/admin',
      //       path: '/main/applications/kanban',
      //       exact: false,
      //       component: <ApplicationsKanban />,
      //     },
      //     {
      //       name: 'Data Tables',
      //       layout: '/admin',
      //       path: '/main/applications/data-tables',
      //       exact: false,
      //       component: <ApplicationsDataTables />,
      //     },
      //     {
      //       name: 'Calendar',
      //       layout: '/admin',
      //       path: '/main/applications/calendar',
      //       exact: false,
      //       component: <ApplicationsCalendar />,
      //     },
      //   ],
      // },
      // {
      //   name: 'Profile',
      //   path: '/main/profile',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Profile Overview',
      //       layout: '/admin',
      //       path: '/main/profile/overview',
      //       exact: false,
      //       component: <ProfileOverview />,
      //     },
      //     {
      //       name: 'Profile Settings',
      //       layout: '/admin',
      //       path: '/main/profile/settings',
      //       exact: false,
      //       component: <ProfileSettings />,
      //     },
      //     {
      //       name: 'News Feed',
      //       layout: '/admin',
      //       path: '/main/profile/newsfeed',
      //       exact: false,
      //       component: <ProfileNewsfeed />,
      //     },
      //   ],
      // },
      // {
      //   name: 'Others',
      //   path: '/main/others',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Notifications',
      //       layout: '/admin',
      //       path: '/main/others/notifications',
      //       exact: false,
      //       component: <OthersNotifications />,
      //     },
      //     {
      //       name: 'Pricing',
      //       layout: '/auth',
      //       path: '/main/others/pricing',
      //       exact: false,
      //       component: <OthersPricing />,
      //     },
      //     {
      //       name: '404',
      //       layout: '/admin',
      //       path: '/main/others/404',
      //       exact: false,
      //       component: <OthersError />,
      //     },
      //     {
      //       name: 'Messages',
      //       layout: '/admin',
      //       path: '/main/others/messages',
      //       exact: false,
      //       component: <Messages />,
      //     },
      //   ],
      // },

      {
        name: 'Configuracion',
        path: '/main/account',
        hidden: true,
        collapse: true,
        items: [
          // {
          //   name: 'Notificaciones',
          //   layout: '/admin',
          //   path: '/main/ERP/Configuracion/Notificaciones',
          //   exact: false,
          //   component: <Notificaciones />,
          // }, 
          
          {
            name: 'Carga Inicial',
            layout: '/admin',
            path: '/main/ERP/Configuracion/CargaInicial',
            exact: false,
            component: <CargaInicial />,
          }, {
            name: 'Ajuste Positivo',
            layout: '/admin',
            path: '/main/ERP/Configuracion/AjustePositivo',
            exact: false,

            component: <AjustePositivo />,
          }, {
            name: 'Ajuste Negativo',
            layout: '/admin',
            path: '/main/ERP/Configuracion/AjusteNegativo',
            exact: false,
            component: <AjusteNegativo />,
          },
        ]
      },
    ],


  },
  // --- Authentication ---
  {
    name: 'Autentificate',
    path: '/auth',
    hidden: true,
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      // --- Sign In ---
      {
        name: 'Inicia Sesion',
        path: '/sign-in',
        collapse: true,
        items: [
          {
            name: 'Default',
            layout: '/auth',
            path: '/sign-in/default',
            component: <SignInDefault />,
          },
          // {
          //   name: 'Centered',
          //   layout: '/auth',
          //   path: '/sign-in/centered',
          //   component: <SignInCentered />,
          // },
        ],
      },
      // // --- Sign Up ---
      // {
      //   name: 'Sign Up',
      //   path: '/sign-up',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Default',
      //       layout: '/auth',
      //       path: '/sign-up/default',
      //       component: <SignUpDefault />,
      //     },
      //     {
      //       name: 'Centered',
      //       layout: '/auth',
      //       path: '/sign-up/centered',
      //       component: <SignUpCentered />,
      //     },
      //   ],
      // },
      // // --- Verification ---
      // {
      //   name: 'Verification',
      //   path: '/verification',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Default',
      //       layout: '/auth',
      //       path: '/verification/default',
      //       component: <VerificationDefault />,
      //     },
      //     {
      //       name: 'Centered',
      //       layout: '/auth',
      //       path: '/verification/centered',
      //       component: <VerificationCentered />,
      //     },
      //   ],
      // },
      // // --- Lock ---
      // {
      //   name: 'Lock',
      //   path: '/lock',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Default',
      //       layout: '/auth',
      //       path: '/lock/default',
      //       component: <LockDefault />,
      //     },
      //     {
      //       name: 'Centered',
      //       layout: '/auth',
      //       path: '/lock/centered',
      //       component: <LockCentered />,
      //     },
      //   ],
      // },
      // // --- Forgot Password ---
      // {
      //   name: 'Forgot Password',
      //   path: '/forgot-password',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Default',
      //       layout: '/auth',
      //       path: '/forgot-password/default',
      //       component: <ForgotPasswordDefault />,
      //     },
      //     {
      //       name: 'Centered',
      //       layout: '/auth',
      //       path: '/forgot-password/centered',
      //       component: <ForgotPasswordCentered />,
      //     },
      //   ],
      // },
    ],
  },
];

export default routes;
